module.exports = __webpack_public_path__ + "as.no2.659c8a8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/as.no2.jpg
// module id = CRku
// module chunks = 0